<template>
  <div>
    <div class="modal fade" data-backdrop="static" id="modal-delete-invoice">
      <div class="modal-dialog" style="width:700px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h2
              class="modal-title"
              style="text-align:left;"
            >{{$t(modalTitle)}}</h2>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row mb-1 margin-down-15">
                    <div class="form-group">
                      <label for="name" class="col-md-3 col-sm-3 control-label" style="margin-top:13px;">{{$t('invoice.modal_delete_invoice.label_delete_type')}}</label>
                      <div class="col-md-6 col-sm-6">
                        <div class="radio">
                          <label>
                            <input type="radio" name="optionsRadios" id="optionsRadios1" value="1" v-model="picked" checked>
                            {{$t('invoice.modal_delete_invoice.label_by_month')}}
                          </label>
                          <label style="margin-left:30px;"></label>
                          <label>
                            <input type="radio" name="optionsRadios" id="optionsRadios2" value="2" v-model="picked">
                            {{$t('invoice.modal_delete_invoice.label_by_selected')}}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

              <div class="row mb-1 margin-down-15" v-if="picked == 1 ? true: false">
                <div class="form-group">
                  <label for="name" class="col-md-3 col-sm-3 control-label">{{$t('invoice.month')}}</label>

                  <div class="col-md-6 col-sm-6">
                    <date-picker
                      :config="optionsPicker"
                      v-model="periodSelected"
                    ></date-picker>
                  </div>

                  <!-- /.input group -->
                </div>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right mg-left"
              @click="onDeleteInvoice"
            >{{$t('common.delete')}}</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModal"
            >{{$t('common.back')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal fade" data-backdrop="static" id="modal-confirm-delete-invoice">
      <div class="modal-dialog" style="width:800px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" style="text-align:left;">{{$t('invoice.modal_delete_invoice_confirm.title')}}</h2>
          </div>
          <div class="modal-body" style="max-height: 700px; overflow: auto;">
            <b-form>
              <div class="row mb-1 margin-down-15" v-if="picked == 2 ? true: false">
                <div class="form-group">
                  <label v-if="count != 0" for="name" class="col-md-6 col-sm-6 control-label" style="margin-top:13px;">{{$t('invoice.modal_delete_invoice_confirm.confirm_head')}} {{count}} {{$t('invoice.modal_delete_invoice_confirm.confirm_tail')}}</label>
                  <label v-if="count == 0" for="name" class="col-md-6 col-sm-6 control-label" style="margin-top:13px;">{{$t('invoice.modal_delete_invoice_confirm.nulldata')}}</label>
                  <div v-if="count != 0" class="col-md-3 col-sm-3">
                    <label class="col-md-12 col-sm-12">{{$t('invoice.invoice_number')}}</label>
                    <span v-for="item in numbersList" v-bind:key="item" class="col-md-12 col-sm-12">{{item}}</span>
                  </div>
                  <div v-if="count != 0" class="col-md-3 col-sm-3">
                    <label class="col-md-12 col-sm-12">{{$t('invoice.apartment_code')}}</label>
                    <span v-for="item in apartmentCodeList" v-bind:key="item" class="col-md-12 col-sm-12">{{item}}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-1 margin-down-15" v-if="picked == 1 ? true: false">
                <div class="form-group">
                  <label for="name" class="col-md-6 col-sm-6 control-label">{{$t('invoice.modal_delete_invoice_confirm.confirm_by_month')}}</label>
                  <div class="col-md-6 col-sm-6">
                    <date-picker
                      disabled
                      :config="optionsPicker"
                      v-model="periodSelected"
                    ></date-picker>
                  </div>
                </div>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              v-if="(count != 0 && picked == 2) || (periodSelected != null && picked == 1)"
              type="button"
              class="btn btn-primary btn-sm pull-right mg-left"
              @click="onDeleteInvoiceConfirm"
            >{{$t('common.delete_modal.btnYes')}}</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModalConfirm"
            >{{$t('common.delete_modal.btnNo')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <!-- model-error-notification -->
     <div class="modal fade" data-backdrop="static" id="modal-message">
      <div class="modal-dialog" style="width:700px !important;">
        <div class="modal-content">
          <div class="modal-body">
          <h3>{{ modal_message }}</h3>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right mg-left"
              @click="closeModalMessage"
            >{{$t('common.back')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
     <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
//import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import Enum from "../../../enum/enum"
import utils from "@/lib/utils";

export default {
  props: {
    invoiceType:{
      type: Number,
      default: () => {
        return Enum.invoiceTypeEnum.MONTHLY
      }
    },
    modalTitle: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  name: "ModalDeleteInvoice",
  data() {
    return {
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      optionsPicker: {
        useCurrent: false,
        minDate: new Date(2019, 0),
        // maxDate: moment().format("YYYY/MM"),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi",
      },

      // Month
      periods: [],
      // Month select
      periodSelected: null,
      // type select for delete
      picked: 1, // 1: month / 2: selected

      idsList: [],
      numbersList: [],
      modal_message: "",
      apartmentCodeList: [],
      count: 0,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {

    /*
    * author : [loitt]
    * function: submit show modal
    * set something info
    */
    submit(periods, data_list, data_number_list, data_apartment_code_list) {
      var today = new Date()
      var date = (today.getMonth()+1)+'-'+today.getFullYear();
      for (let index = 0; index < periods.length; index++) {
        const element = periods[index];
        const date_from = parseInt(element.date_from.split("-")[1]) + "-" + element.date_from.split("-")[0]
        if (date_from == date)
        {
          this.periodSelected = index + 1
        }
      }

      this.periods = periods
      // set list invoice select
      this.idsList = data_list
      this.numbersList = data_number_list
      this.apartmentCodeList = data_apartment_code_list
      this.count = data_number_list.length
      $('#modal-delete-invoice').modal("show");
    },

    /*
    * author : [loitt]
    * function: close Modal
    */
    closeModal: function() {
      $('#modal-delete-invoice').modal("hide");
      this.disabledCheckin = true;
    },
    closeModalConfirm: function() {
      $('#modal-confirm-delete-invoice').modal("hide");
      $('#modal-delete-invoice').modal("show");
    },
    closeModalMessage: function(){
      $('#modal-message').modal("hide");
    },
    /*
    * author : [loitt]
    * function: onDeleteInvoice
    *       process delete invoice
    *       callBackActionDeleteInvoice
    */
    onDeleteInvoice: function() {
      if (this.picked == 1 && utils.isEmptyString(this.periodSelected)) {
        this.ON_SHOW_TOAST({
          message: this.$t('invoice.month'),
          styleType: "danger"
        });
      } else if(this.picked == 2 && this.idsList.length < 1) {
        this.ON_SHOW_TOAST({
          message: this.$t('invoice.pleaseSelectInvoiceDelete'),
          styleType: "danger"
        });
      } else {
        $('#modal-delete-invoice').modal("hide");
        $('#modal-confirm-delete-invoice').modal("show");
      }
    },

    onDeleteInvoiceConfirm: function() {
      this.removeInvoice()
      this.picked = 1
      this.numbersList = []
      this.apartmentCodeList = []
      $('#modal-confirm-delete-invoice').modal("hide");
      this.$emit("callBackActionDeleteInvoice", this.idsList);
    },

    /*
    * author : [loitt]
    * function: removeInvoice
    *       call API delete invoice
    */
    async removeInvoice(){
      let periodSelectedFormat = utils.formatSqlDate(this.periodSelected, "YYYY/MM", "YYYYMM")
      let  data = {
        "type": this.picked,
        "data": (this.picked == 2) ? this.idsList : periodSelectedFormat,
        invoiceType: this.invoiceType
      }
      this.isLoading = true
      await this.DELETE_INVOICE_LIST(data).then(
          function(res){
              this.isLoading = false
              // this.SUCCESS_TOAST()
              let count_deleted_fail = res.count_deleted_fail
              let count_deleted_success = res.count_deleted_success
              this.ON_SHOW_TOAST({
                message: this.$t("invoice.notiCountDeleteInvoice", {'0': count_deleted_success, '1': count_deleted_fail}),
                styleType: count_deleted_fail > 0 ? "warning" : "success"
              });
          }.bind(this)
      )
      .catch(
          function(error) {
              // this.ERROR_TOAST()
              this.isLoading = false
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
          }.bind(this)
      )
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "DELETE_INVOICE_LIST"
    ])
  },
  mounted() {},
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    "date-picker": datePicker,
  }
};
</script>
<style lang="scss" scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Invoice/ModalDeleteInvoice.vue